import { useNavigate } from 'react-router-dom';
import classNames from 'classnames/bind';

import styles from './Product.module.scss';
// import LinkButton from '../../../components/linkButton';

const cx = classNames.bind(styles);

const Product = ({ data }) => {
  const navigate = useNavigate();

  const moveToDetail = () => {
    // navigate(data.uri);
  };

  return (
    <li className={cx(['container', data.color])}>
      <p className={cx('line')}>{data.line}</p>
      <h3 className={cx('name')}>{data.name}</h3>
      <img src={data.openImage} alt={data.title} draggable={false} className={cx('openImage')} onClick={moveToDetail} />
      <img src={data.closeImage} alt={data.title} draggable={false} className={cx('closeImage')} />
      <p className={cx('title')}>{data.title}</p>
      {/* <LinkButton title="SHOW DETAIL" link={data.uri} color={data.title} /> */}
    </li>
  );
};

export default Product;
